import * as actions from '../utils/Constants';
import { apiGet, apiDeleteWithBodyAndThen, apiRequest, Methods } from '../utils/Api';

const apiTrainingType = `${process.env.REACT_APP_API_HOST}api/trainingType/`;
const apiTrainingTypes = `${process.env.REACT_APP_API_HOST}api/trainingTypes`;

export const getTrainingTypes = () => ({
    type: actions.GET_TRAINING_TYPES,
    payload: apiGet(apiTrainingTypes)
});

export const getTrainingType = (id) => ({
    type: actions.GET_TRAINING_TYPE,
    payload: apiGet(apiTrainingType + id)
});

export const deleteTrainingTypes = (ids = []) => ({
    type: actions.DELETE_TRAINING_TYPE,
    payload: apiDeleteWithBodyAndThen(apiTrainingTypes, ids, () => apiGet(apiTrainingTypes))
});

export const newTrainingType = () => ({ type: actions.NEW_TRAINING_TYPE })

export const getTrainingTypesPickList = () => dispatch =>
    dispatch({
        type: actions.GET_TRAININGTYPES_PICKLIST,
        payload: apiRequest(`${process.env.REACT_APP_API_HOST}api/trainingtypes/picklist`, Methods.get, null, dispatch)
    });
